import React from 'react';
import { MatchHighlight } from 'models/Search';
import { isOdd } from 'utils';

export const escapeRegex = (str: string) =>
  str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const getOffsetHighlightNodes = (
  text: string,
  highlights: MatchHighlight[],
): React.ReactNode[] => {
  const sortedHighlights = [...highlights].sort((a, b) => a.start - b.start);

  const nodes: React.ReactNode[] = [];
  let cursor = 0;

  sortedHighlights.forEach(({ start, length }, index) => {
    if (start > cursor) nodes.push(text.slice(cursor, start));

    nodes.push(
      <span key={index} className="text-highlighter__tag">
        {text.slice(start, start + length)}
      </span>,
    );

    cursor = Math.max(cursor, start + length);
  });

  if (cursor < text.length) nodes.push(text.slice(cursor));

  return nodes;
};

export const getRegexHighlightNodes = (
  text: string,
  highlighter: string | RegExp,
): React.ReactNode[] => {
  const regex =
    typeof highlighter === 'string'
      ? new RegExp(`(${escapeRegex(highlighter)})`, 'i')
      : highlighter;

  return text?.split(regex).map((part, index) =>
    isOdd(index) ? (
      <span key={index} className="text-highlighter__tag">
        {part}
      </span>
    ) : (
      part
    ),
  );
};
